export const getTitle = (option: com.ts.mobile.sdk.AuthenticationOption, actionContext: com.ts.mobile.sdk.PolicyAction | null) => {
  let authenticatorId = option.getAuthenticator().getAuthenticatorId();
  let uiContext = actionContext ? actionContext.getUiContext() : {getString: (key: string) => key};

  switch (authenticatorId) {

    case "otp_giam_104596_sms_otp" :
      return uiContext.getString("ts_authenticator_otp_giam_104596_sms_otp");
    case "otp_giam_104596_voice_otp" :
      return uiContext.getString("ts_authenticator_otp_giam_104596_voice_otp");
    case "otp_giam_104596_email_otp" :
      return uiContext.getString("ts_authenticator_otp_giam_104596_email_otp");
    default :
      return option.getAuthenticator().getName();
  }
}

export const getInitiatingPolicyId = (actionContext?: com.ts.mobile.sdk.PolicyAction | null): string => (
  actionContext ? (actionContext as any).controlFlow.initiatingRequest.body.policy_request_id : ""
);
